import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { selectIsLoading } from '@/store'

export const AppLoader = () => {
  const loading = useSelector(
    selectIsLoading('project', 'project_create', 'authentication')
  )

  useEffect(() => {
    if (loading) {
      document.body.classList.remove('--loaded')
      return
    }

    document.body.classList.add('--loaded')
  }, [loading])

  return null
}
